import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { axiosInstance } from './axios';

class PromotionApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/promotion');
  }

  protected transformNode(node: any) {
    // Add computed status based on dates and enabled flag
    const currentDate = new Date();
    const startDate = new Date(node.startTime);
    const endDate = new Date(node.endTime);

    if (!node.enabled) {
      node.status = 'DISABLED';
    } else if (currentDate < startDate) {
      node.status = 'SCHEDULED';
    } else if (currentDate > endDate) {
      node.status = 'EXPIRED';
    } else {
      node.status = 'ACTIVE';
    }

    return node;
  }

  // Add method to update promotion SKUs (for CSV upload)
  async updatePromotionSkus(promotionId: number, data: any) {
    const response = await axiosInstance.post(`${this.baseURL}/update-skus`, {
      promotionId,
      ...data,
    });
    return response.data;
  }

  // Add method to trigger auto-populate
  async triggerAutoPopulate(promotionId: number) {
    const response = await axiosInstance.post(`${this.baseURL}/${promotionId}/auto-populate`);
    return response.data;
  }
}

export default PromotionApiClient;
